/// <amd-module name="Test/TestPlansHubRefresh/Pivots/ExecutePivot/ExecuteConstants" />

export const ExecuteTabZeroDataImagePath = "ms.vss-test-web/testplan-hub-refresh-assets/zero-data-execute-tab.png";
export const UnassignedIdentityIconPath = "ms.vss-test-web/testplan-hub-refresh-assets/unassigned-icon.svg";
export const ExecutePivotName = "Execute";
export const AssignTesterIconName = "PeopleAdd";
export const ViewTestResultIconName = "History";
export const ResumeTestIconName = "PlayResume";
export const UnassignedIdentityGuid = "00000000-0000-0000-0000-000000000000";
export const User = "user";
export const Scope = "ims";
export const HideDTRLaunchDialogCookieName = "HideDTRLaunchDialog";
export const ShowDTRVersionUpdateMessageCookieName = "ShowDTRVersionUpdateMessage";
export const WorkItemTypeCategoryForWebRunner = "Microsoft.BugCategory";
export const DefaultWorkItemTypeForWebRunner = "Bug";
export const TestCaseWorkItemType = "Test Case";
export const TestResultsContributionId = "ms.vss-test-web.test-runs-route";
export const queryParams = "?_a=resultSummary&runId={0}&resultId={1}";
export const ResetTestToActiveIconName = "Refresh";
export const ViewExecutionHistoryIconName = "History";
export const MarkOutcomeIconName = "CheckMark";
export const PassTestIconName = "CompletedSolid";
export const FailTestIconName = "StatusErrorFull";
export const BlockTestIconName = "Blocked2Solid";
export const NotApplicableIconName = "BlockedSolid";
export const RunIconName = "Play";
export const EditTestIconName = "Edit";
export const SuiteCountThreshold = "SuiteCountThreshold";
export const SuiteTestCasesBatchSize = 200;

export const TestCaseIdColumn = "TestCaseIdColumn";
export const OrderColumn = "OrderColumn";
export const OutcomeColumn = "OutcomeColumn";
export const TitleColumn = "TitleColumn";
export const TesterColumn = "TesterColumn";
export const ConfigurationColumn = "ConfigurationColumn";
export const ConfirmationDialogType = "dialog";
export const TestPointDragItemType = "test-point-item";
export const DragTestPointsText = "test points";
export const WorkItemTypeCategoryTestCase = "Microsoft.TestCaseCategory";
